   <template>
  <div class="app7" :class="{ app7White: isWhite }">
    <div class="head" :class="{ headWhite: isWhite }">
      <van-search
        v-model="questionNameLike"
        placeholder="请输入关键词"
        @input="questionLike"
        v-if="isOldShow"
        class="OldInput"
        :clearable="false"
      />

      <div class="NewInputZu" v-if="isNewInputShow">
        <van-search
          v-model="questionNameLike"
          placeholder="请输入关键词"
          @input="questionLike"
          class="NewInput"
          :clearable="false"
        />
        <p @click="clearInput">取消</p>
      </div>
    </div>

    <div class="container7" :class="{ container7White: isWhite }">
      <div class="helpList">
        <div v-for="item in helpList1" :key="item.id" class="inHelp">
          <div class="questionTitle">{{ item.question }}</div>
          <div class="answer">
            {{ item.answer }}
          </div>
          <div class="tips">
            {{ item.tips }}
          </div>
        </div>
      </div>
    </div>

    

    <div class="wule">
      <div class="leftStyle">
        <div class="shadowLine left"></div>
      </div>
      <span> <img src="../assets/images/lines2.svg" alt="" /></span>
      <div class="centerWord">没有更多了</div>
      <span> <img src="../assets/images/lines2.svg" alt="" /></span>
      <div class="rightStyle">
        <div class="shadowLine right"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import qs from "qs";
import { doRem } from "../utils/setrem";
import Vue from "vue";
import { Search } from "vant";
import { DropdownMenu, DropdownItem } from "vant";
import { List } from "vant";
import { Dialog } from "vant";
import { Icon } from "vant";
Vue.use(Icon);

Vue.use(List);

Vue.use(DropdownMenu);
Vue.use(DropdownItem);

Vue.use(Search);

export default {
  mounted() {

    this.helpList1 = JSON.parse(JSON.stringify(this.helpList));
  },
  data() {
    return {
      commonList: true,
      isLike: false,
      isWhite: false,
      isOldShow: true,
      isBottomTipShow: false,
      isNewInputShow: false,

      areaPopup: false,
      juliPopup: false,

      questionNameLike: "",

      helpList: [
        {
          id: 1,
          question: "如何开通“鹿路通”扫码乘车功能？",
          answer:
            "安卓手机和苹果手机均支持“鹿路通”扫码乘车功能，需在各应用市场下载、注册“鹿路通”APP，在主页面选择【扫码乘车】→选择【L2级-实名认证】完成通过后即开通成功。",
          tips: "",
        },
        {
          id: 2,
          question: "使用“鹿路通”乘车码是否需要实名认证？",
          answer:
            "您好，乘车码需要实名认证。为保证市民账户资金安全和售后服务的需要，开通扫描乘车时需完成实名认证。",
          tips: "",
        },
        {
          id: 3,
          question: "使用“鹿路通”扫码乘车账户余额需要多少余额？",
          answer: "您好，扫描乘车账户余额不能低于昆山公交的最低票价额度。",
          tips: "",
        },
        {
          id: 4,
          question: "“鹿路通”乘车码充值有几种方式？",
          answer:
            "您好，“鹿路通”乘车码充值共有三种不同充值方式，分别为支付宝、微信及昆山农村商业银行。市民可任选其一完成充值。  ",
          tips: "",
        },
        {
          id: 5,
          question: "如何使用扫码乘车支付车费？",
          answer:
            "您好，使用乘车码支付车费时需要打开“鹿路通”APP——点击“扫描乘车”——乘车码对准POS机扫码口－－语音提示“扫码成功”即表示支付成功。",
          tips: "",
        },
        {
          id: 6,
          question: "是否支持微信、支付宝扫码支付？",
          answer:
            "您好，昆山公交乘车扫码技术正处千发展中阶段，根据开发进度分阶段实施，现阶段可支持“鹿路通”乘车码，暂不支持微信或支付宝扫码。",
          tips: "",
        },
        {
          id: 7,
          question: "先扫码后扣费，是否会存在乱扣费的情况？",
          answer:
            "您好，昆山老市民卡（卡号以'2153'开头）不支持苏州地铁刷卡消费；昆山新市民卡和新昆通卡（卡号以'31048315'开头）支持苏州地铁出刷卡消费。",
          tips: "小贴士:客服热线：0512-55162603",
        },
        {
          id: 8,
          question: "有哪些公交线路支持“鹿路通”扫码乘车功能？",
          answer: "您好，昆山市范围内所有公交线路均可支持“扫码乘车”功能。",
          tips: "",
        },
        {
          id: 9,
          question: "“鹿路通”乘车码是否支持带人乘坐公交车？",
          answer:
            "您好，一票制线路公交可支持代人支付。为保证乘客账户资金安全，一个乘车码只能交易一次。代人支付需要乘客手动刷新乘车码（自动刷新时间为60秒）。多票制线路公交不支持代人支付。",
          tips:
            "为保证乘客上车秩序与安全，昆山市民卡提醒市民谨慎使用代人支付功能。",
        },
        {
          id: 10,
          question: "请问“鹿路通”乘车码在网络不通的清况能生成吗？",
          answer:
            "您好，“鹿路通”乘车码只能在网络畅通下生成乘车码。昆山市民卡提醒市民使用乘车码时确保网络畅通。",
          tips: "",
        },
        {
          id: 11,
          question: "多票制线路如何刷码？如何计费？",
          answer:
            "您好多票制线路公交的上客门（前门）和下客门（后门），均有安装POS机。乘客在使用乘车码过程中需要在上车时（前门）先扫—次码，下车时（后门）再扫—次码。系统将自动根据乘客两次扫码时乘坐的区间扣除相应金额。",
          tips: "",
        },
        {
          id: 12,
          question: "使用乘车码乘坐公交时有哪些语音提示？",
          answer:
            "您好，乘车码乘坐公交车时的语音提示有两种状态：—、扫码成功：语音提示——'刷码成功' 二、扫码失败：(1)	语音提示——“二维码格式错误”。此提示表明a.用户使用了非“鹿路通”APP的乘车码b.刷码时靠的太近，需重新以正确的姿势刷码即可；(2)	语音提示——”二维码已过期”。此提示表明用户使用的乘车码已过期，用户手动刷新乘车码即可；(3)	语音提示——“二维码重复使用”。此提示表明用户重复使用同—个二维码，用户手动刷新乘车码即可。 ",
          tips: "",
        },
        {
          id: 13,
          question: "为什么乘车码无法显示？",
          answer:
            "您好，乘车码无法显示通常有以下因素：—、用户乘车码区域不显示且报错余额不足，此种状态用户充值后即可正常使用。二、“鹿路通”APP为旧版本——此种状态用户卸载旧版本“鹿路通”APP和云充值管理平台后重新下载最新版本“鹿路通”APP即可正常使用。三、手机端日期时间因素——此种状态用户将手机端日期时间设置成北京时间，并网络同步自动更新即可正常使用。",
          tips: "",
        },
        {
          id: 14,
          question:
            "扫码乘车功能旧手机号码不用了，如果想换绑成新的手机号码该怎么办？",
          answer:
            "您好，换绑新号码流程为：登录“鹿路通”APP——点击页面最下方“异常申诉”点击“我要换新手机号，找回旧账户的余额和身份证号”——填写资料“之前开通扫码的用户姓名＋身份证号＋身份证照片＋旧手机号码＋新手机号码＋验证码”——点击“提交”等待审核通过即可。",
          tips: "",
        },
        {
          id: 15,
          question:
            "扫码乘车功能旧手机号码不用了（收不到验证码了），如何将账户里的余额提现？",
          answer:
            "您好，具体流程：登录“鹿路通”APP——点击页面最下方“异常申诉”——点击“我要注销旧账号，提现账户余额”——填写资料“已注册扫码的用户姓名＋身份证号＋身份证照片＋旧手机号码＋新手机号码＋验证码＋支付宝账号”——点击“提交”等待审核（8-10个工作日）后系统将自动退还全部余额至您提供的支付宝账户内。",
          tips:
            "小贴士：1、用户可通过异常处理进度查询审核状态2、退款后您的扫码乘车账户将被冻结—个自然月，期间将无法正常使用该功能。3、为保证账户资金安全，请您填写资料时仔细核对支付宝账号信息，如因账户信息填写错误而导致系统退款至他人账户的情况，—切损失将由您个人自行承担。",
        },
        {
          id: 16,
          question: "扫码乘车功能暂时不想用了，怎样操作才能将账户余额提现？",
          answer:
            "您好，退资流程：登录“鹿路通”APP——点击“扫码乘车”——点击右上角【．．】－－点击“注销退款”——填写资料“支付宝账号”——点击“确认”后系统将会在10个工作日内将全部余额退还至您提供的支付宝账户内。",
          tips:
            "小贴士：1、退款后您的扫码乘车账户将被冻结一个自然月，期间将无法正常使用该功能。2、为保证账户资金安全，请您填写资料时仔细核对支付宝账号信息，如因账户信息填写错误而导致系统退款至他人账户的情况，一切损失将由您个人自行承担。",
        },
        {
          id: 17,
          question: "怎么更改平台手机号码？",
          answer:
            "您好，平台更改手机号码流程：登录“鹿路通”APP——点击“我的”——点击“设置”——点击“我的账号”——点击“变更手机号”重新设置。",
          tips: "",
        },
      ],
      helpList1: [],

      loading: false,
      finished: false,
      pageLimit: 10,
      currentPage: 1,
    };
  },
  methods: {
    questionLike() {
     

      this.isLike = true;
      this.isOldShow = false;
      this.isNewInputShow = true;
      this.helpList1 = [];
      this.isWhite = true;
     
      let list = this.helpList.filter((v) => {
        if (
          v.question.includes(this.questionNameLike) ||
          v.answer.includes(this.questionNameLike) ||
          v.tips.includes(this.questionNameLike)
        ) {
          return v;
        }
      });
      console.log(list);
      this.helpList1 = list;
    },

    clearInput() {
      this.questionNameLike = "";
      this.isOldShow = true;
      this.isNewInputShow = false;
      this.helpList1 = JSON.parse(JSON.stringify(this.helpList));
      this.isWhite = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/UseHelp.scss";
</style>

<style lang="scss" scoped>
.headWhite,
.app7White {
  background-color: #ffffff;
}
.container7White {
  background-color: #ffffff;
  margin-top: 8.25rem;
}

.head ::v-deep .OldInput {

  height: 5rem;
  background: #ffffff;
  padding: 0;
  border-radius: 2.5rem;
  .van-search__content {
    border-radius: 2.5rem;
    padding-left: 2.625rem;
    background: #ffffff;

    .van-cell {
      padding: 0;

      .van-cell__value--alone .van-field__body .van-field__control {
        font-size: 1.75rem;
        color: #878787;
        margin-left: 0.625rem;
      }

      .van-field__left-icon .van-icon {
        font-size: 2.5rem;
        color: #878787;
      }
    }
  }
}

.NewInputZu {
  display: flex;
  align-items: center;
  p {
    font-size: 1.75rem;
    color: #338989;
    margin-left: 1.75rem;
    white-space: nowrap;
  }
}
.head ::v-deep .NewInput {
  width: 36.625rem;
  height: 5rem;
  background: #f9f9f9;
  padding: 0;
  border-radius: 2.5rem;
  .van-search__content {
    border-radius: 2.5rem;
    padding-left: 2.625rem;
    background: #f9f9f9;

    .van-cell {
      padding: 0;

      .van-cell__value--alone .van-field__body .van-field__control {
        font-size: 1.75rem;
        color: #878787;
        margin-left: 0.625rem;
      }

      .van-field__left-icon .van-icon {
        font-size: 2.5rem;
        color: #878787;
      }
    }
  }
}
</style>